import { useEffect, useState } from "react";
import { Menu, X, Lock } from "lucide-react";
import Logo from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { hash: "#metiers", label: "01. Métiers" },
  { hash: "#realisations", label: "02. Réalisations" },
  { hash: "#entreprise", label: "03. L'entreprise" },
  { hash: "#contact", label: "04. Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (hash) => {
    setOpen(false);
    setTimeout(() => scrollToId(hash), open ? 150 : 0);
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 border-b ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-black/10 shadow-sm"
          : "bg-transparent border-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="w-full pl-1 pr-5 md:pl-2 md:pr-8 h-[100px] flex items-center justify-between">
        <button onClick={() => go("#top")} data-testid="nav-logo-button" aria-label="CITEK — retour en haut">
          <Logo />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              onClick={() => go(l.hash)}
              data-testid={`nav-link-${l.hash.slice(1)}`}
              className="font-tech text-[13px] uppercase tracking-[0.18em] text-zinc-600 hover:text-citek-greenDark transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="/admin"
            data-testid="nav-admin-link"
            aria-label="Espace administrateur"
            className="hidden lg:flex h-10 w-10 items-center justify-center border border-black/15 rounded-md text-zinc-500 hover:text-citek-greenDark hover:border-citek-greenDark/50 transition-colors"
          >
            <Lock size={16} />
          </a>
          <button
            onClick={() => go("#contact")}
            data-testid="nav-cta-button"
            className="hidden sm:inline-flex bg-citek-green text-black font-semibold text-base px-6 py-3 rounded-md hover:bg-citek-greenBright transition-colors"
          >
            Demande de devis
          </button>
          <button
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
            className="lg:hidden h-10 w-10 flex items-center justify-center border border-black/15 rounded-md text-zinc-800"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-black/10 px-5 py-4 space-y-1" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              onClick={() => go(l.hash)}
              className="block w-full text-left font-tech text-sm uppercase tracking-[0.18em] text-zinc-600 hover:text-citek-greenDark py-3.5 border-b border-black/5"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("#contact")}
            data-testid="nav-mobile-cta"
            className="mt-3 w-full bg-citek-green text-black font-semibold text-base px-5 py-3.5 rounded-md"
          >
            Demande de devis
          </button>
        </div>
      )}
    </header>
  );
}
